import { Box, Typography } from '@mui/material';
import { Alert } from 'sharedComponents/Alert';
import { ATSJobViewDataTestIds } from 'data-testids/ATS';
import { PrimaryButton } from 'sharedComponents/Buttons';
import { useHistory } from 'react-router-dom';
import auth from 'utils/auth';

export interface JobClosedMessageProps {
  showBackToDashboardButton?: boolean;
}

export const JobClosedMessage: React.FC<JobClosedMessageProps> = ({
  showBackToDashboardButton = false,
}) => {
  const history = useHistory();

  return (
    <Box sx={{ width: '100%', mb: 2 }}>
      <Alert dataTestId={ATSJobViewDataTestIds.JOB_CLOSED_BANNER} type="warning">
        <Typography component="span" sx={{ fontWeight: 600 }}>
          This job is no longer accepting applications.
        </Typography>
      </Alert>
      {showBackToDashboardButton && auth.loggedIn() && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
          <PrimaryButton
            dataTestId={ATSJobViewDataTestIds.JOB_CLOSED_BACK_TO_DASHBOARD_BUTTON}
            onClick={() => history.push('/candidate-dashboard')}
          >
            Back to Dashboard
          </PrimaryButton>
        </Box>
      )}
    </Box>
  );
};
